import React from "react";
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white pt-20 pb-10 px-6 font-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* 1. BRAND SECTION */}
          <div className="space-y-6">
            <div className="space-y-8">
              <img 
                src="https://ik.imagekit.io/igxrggga8/pcworldraipur.in/logo/Pc%20world%20Logowh.png?updatedAt=1762158575262" 
                alt="PC World Raipur Logo" 
                className="h-14 w-auto object-contain"
              />
              <p className="text-slate-400 text-sm leading-relaxed font-medium">
                Raipur's premier B2B IT infrastructure provider. Empowering businesses with enterprise-grade tech.
              </p>
              
              <motion.a
                href="https://pcworldraipur.in/downloadV2.apk"
                download
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center gap-3 bg-white text-slate-950 px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-xl transition-all hover:bg-blue-600 hover:text-white group"
              >
                <span className="text-lg">🤖</span>
                Download App (APK)
              </motion.a>
            </div>
          </div>

          {/* 2. QUICK LINKS - Added Career here */}
          <div>
            <h4 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-8">Navigation</h4>
            <ul className="space-y-4">
              {["Home", "About", "Services", "Gallery", "Contact"].map((item) => (
                <li key={item}>
                  <Link 
                    to={item === "Home" ? "/" : `/${item.toLowerCase()}`} 
                    className="text-slate-300 hover:text-white text-sm font-bold transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
              {/* SPECIAL LINK: CAREERS (Opens in New Tab) */}
              <li>
                <a 
                  href="/careers" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-white text-sm font-black transition-colors flex items-center gap-2"
                >
                  Careers <span className="text-[10px]">↗</span>
                </a>
              </li>
            </ul>
          </div>

          {/* 3. EXPERTISE */}
          <div>
            <h4 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-8">Expertise</h4>
            <ul className="space-y-4 text-slate-300 text-sm font-bold">
              <li>Enterprise Servers</li>
              <li>Network Solutions</li>
              <li>AMC Support</li>
              <li>Bulk Procurement</li>
            </ul>
          </div>

          {/* 4. CONTACT */}
          <div>
            <h4 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-8">Location</h4>
            <div className="space-y-4 text-slate-300 text-sm font-bold">
              <p>📍 Nagdev Plaza, Jail Rd, Raipur, CG</p>
              <p>📞 +91 93027 07699</p>
              <p className="lowercase">✉️ salesraipur@pcworldraipur.in</p>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] font-black uppercase tracking-widest text-slate-500">
            © {currentYear} PC World Raipur.
          </p>
          <div className="flex gap-8">
            <Link to="/privacy" className="text-slate-500 hover:text-white text-[10px] font-black uppercase tracking-widest transition-colors">Privacy</Link>
            <Link to="/terms" className="text-slate-500 hover:text-white text-[10px] font-black uppercase tracking-widest transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}